import { getApp } from 'firebase/app';

export function getFirebaseApp() {
  return getApp();
}
